import {useState} from 'react'
import {Button, Flash} from '@primer/react'
import {announce} from '@github-ui/aria-live'
import {useDisableAutoMergeMutation} from '../../hooks/mutations/use-disable-auto-merge-mutation'
import {useSidebarMergeData} from './use-sidebar-merge-data'

export function SidebarDisableAutoMerge() {
  const {mergeBoxPullRequest} = useSidebarMergeData()
  const viewerCanDisableAutoMerge = mergeBoxPullRequest?.viewerCanDisableAutoMerge ?? false

  const [errorMessage, setErrorMessage] = useState<string>()
  const {mutate: disableAutoMerge, isPending} = useDisableAutoMergeMutation({
    onError: (e: Error) => {
      setErrorMessage(e.message)
      announce(e.message)
    },
  })

  return (
    <div className="d-flex flex-column gap-2 pt-2">
      {errorMessage && <Flash variant="danger">{errorMessage}</Flash>}
      <Button
        block
        variant="danger"
        disabled={isPending || !viewerCanDisableAutoMerge}
        loading={isPending}
        loadingAnnouncement="Disabling auto-merge"
        onClick={() => {
          setErrorMessage(undefined)
          disableAutoMerge()
        }}
      >
        Disable auto-merge
      </Button>
    </div>
  )
}
